module.exports = __webpack_public_path__ + "static/media/tb-hero.37603feb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TeamBuilding/tb-hero.png
// module id = 611
// module chunks = 0